<script setup lang="ts">
interface Props {
  currentBrand?: string;
}

const props = withDefaults(defineProps<Props>(), {
  currentBrand: '',
});
</script>

<template>
  <div class="quality-assurance">
    <RouterView
      v-slot="{ Component }"
    >
      <component
        :is="Component"
        :current-brand="props.currentBrand"
      />
    </RouterView>
  </div>
</template>
